import React, { FC } from 'react';
import styles from '../styles.module.scss';
import { FormattedMessage } from 'react-intl';
import auditLogMsgs from 'common/dist/messages/auditLog';

export const OverlayAuditLog: FC = () => {
  return (
    <div className={styles.subheaderLeft}>
      <div className={styles.subheaderSimpleHeadlineContainer}>
        <div className={styles.subheaderSimpleHeadline}>
          <FormattedMessage {...auditLogMsgs.msgAuditLog} />
        </div>
      </div>
    </div>
  );
};

export default OverlayAuditLog;
